"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var HubSubtitle = _styledComponents.default.div.withConfig({
  displayName: "HubSubtitle",
  componentId: "sc-54n1iz-0"
})(["color:", ";font-size:14px;line-height:24px;text-align:center;margin-bottom:20px;"], _colors.OBSIDIAN);

var _default = HubSubtitle;
exports.default = _default;
module.exports = exports.default;